var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperateAc1Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 3.33317V12.1165C12.302 12.4834 12.7986 13.0497 13.0794 13.7276C13.3602 14.4056 13.4095 15.1572 13.2196 15.866C13.0297 16.5748 12.6112 17.2011 12.029 17.6478C11.4469 18.0945 10.7336 18.3366 9.99984 18.3366C9.26606 18.3366 8.55278 18.0945 7.97063 17.6478C7.38849 17.2011 6.97 16.5748 6.78009 15.866C6.59017 15.1572 6.63943 14.4056 6.92024 13.7276C7.20105 13.0497 7.6977 12.4834 8.33317 12.1165V3.33317C8.33317 2.89114 8.50877 2.46722 8.82133 2.15466C9.13389 1.8421 9.55781 1.6665 9.99984 1.6665C10.4419 1.6665 10.8658 1.8421 11.1783 2.15466C11.4909 2.46722 11.6665 2.89114 11.6665 3.33317Z",
    stroke: "#00A63E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperateAc1Icon);
export default __webpack_public_path__ + "static/media/operate_ac_1_icon.0f25d249b426cd5866cd5ec15cc55309.svg";
export { ForwardRef as ReactComponent };